module.exports = __webpack_public_path__ + "img/14.49503ed0.jpg";